import React, {createContext, useContext, useEffect, useState} from 'react';
import axios from "axios";
import apiClient from "./apiClient";
import { useLocation } from 'react-router-dom';

const AuthContext = createContext(undefined);

const baseURL = process.env.REACT_APP_API_BASE_URL;

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const location = useLocation();


  useEffect(() => { // Zugriff auf die aktuelle Route
    const excludedRoutes = ['/login', '/mfa-verify']; // Seiten, auf denen kein Auth-Check nötig ist

    if (excludedRoutes.includes(location.pathname)) {
      // Keine Authentifizierung nötig auf den ausgeschlossenen Seiten
      setLoading(false);
      return;
    }

    const checkAuth = async () => {
      try {
        const response = await apiClient.get('/auth/me', { withCredentials: true });
        console.log('User data retrieved:', response.data);
        setUser({ username: response.data }); // Benutzerinformationen setzen
      } catch (error) {
        console.log('Auth check failed:', error);
        setUser(null); // Benutzer abmelden
      } finally {
        setLoading(false); // Authentifizierungsprüfung abgeschlossen
      }
    };

    checkAuth(); // Authentifizierung nur ausführen, wenn der Benutzerzustand nicht null ist
  }, [location.pathname]);



  const login = async (username, password, navigate) => {
    await axios.post(baseURL + '/auth/login', { username, password }, { withCredentials: true });
    setUser({ username });
    navigate('/mfa-verify');
  };

  const logout = async () => {
    try {
      console.log('Trying to log out:');
      await axios.post(baseURL + '/auth/custom-logout', null, { withCredentials: true });
      setUser(null);
      console.log('Logged out successfully:');
    } catch (error) {
      console.error('Logout fehlgeschlagen:', error);
    }
  };

  // Füge 'loading' zum Kontextwert hinzu
  const value = { user, login, logout, loading };
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};


export const useAuth = () => useContext(AuthContext);

